import { createAppSlice } from '!core/redux';

const initialState = {
  main: { data: [] },
  modules: [],
  isLoading: false,
  isOpen: false,
  activeMenuItem: 'LANDING_PAGE',
  activeNavigationMenuItem: '',
};

export const menusSlice = createAppSlice({
  name: 'menusSlice',
  initialState,
  reducers: {
    menuRequest: (state) => {
      state.isLoading = true;
    },
    menuSucess: (state, action) => {
      const { menuId, mainMenu } = action.payload;
      state.isLoading = false;
      state[menuId].data = mainMenu;
    },
    menuFailure: (state) => {
      state.isLoading = false;
    },
    toggleOpenMenu: (state) => {
      state.isOpen = !state.isOpen;
    },
    setActiveMenuItem: (state, action) => {
      const { activeMenuItem } = action.payload;
      state.activeMenuItem = activeMenuItem;
    },
    setActiveNavigationMenuItem: (state, action) => {
      const { activeNavigationMenuItem } = action.payload;
      state.activeNavigationMenuItem = activeNavigationMenuItem;
    },
  },
});
